import areaService from "@/services/area";

const getDefaultState = () => {
    return {
        areaList: [],
        loading: false,
    };
};

export const state = getDefaultState();

export const actions = {
    fetchAreaList({ commit },) {
        commit("grid/setLoading", true, { root: true });
        return new Promise((resolve, reject) => {
            areaService
                .getEntityAreas()
                .then((data) => {
                    resolve(data);
                    commit("setAreaList", data.data);
                    commit("grid/setLoading", false, { root: true });
                })
                .catch((err) => {
                    reject(err);
                    commit("grid/setLoading", false, { root: true });
                });
        });
    },
};


export const mutations = {
    resetAreaState(state) {
        // Merge rather than replace so we don't lose observers
        Object.assign(state, getDefaultState())
    },
    setAreaList(state, payload) {
        state.areaList = payload;
    },
    setLoading(state, payload) {
        state.loading = payload;
    },
};

export const getters = {
    getAreaList(state) {
        return state.areaList;
    },
    getLoading(state) {
        return state.loading;
    },
};